<div *ngIf="renderStats" class="flex items-start w-full">
  <div *ngFor="let stat of renderStats" class="text-center w-1/6">
    <div class="h-20 px-1 py-4 bg-blue-600 font-bold border border-white text-white flex items-center justify-center">
      <span>{{ stat.label }}</span>
    </div>
    <div class="h-8 px-1 py-1 bg-gray-400 font-bold border border-white">
      {{ stat.value }}
    </div>
  </div>
</div>